import type { Column } from "@/components/ui/data-table"

import {
  ClientCell,
  MembersCell,
  PrimaryClientContactCell,
  ReviewsCell,
  SinceCell,
} from "./clients-cells"
import type { ClientRow, PrimaryClientContact } from "./clients-data"

export function buildClientsColumns(
  resolvePrimaryClientContact: (row: ClientRow) => PrimaryClientContact | null,
): Column<ClientRow>[] {
  // Client takes a fixed share (up to a third of the table) instead of absorbing all the slack,
  // and the four columns after it split what is left evenly. Every column after the first is
  // centred, header and cell alike, as on Users.
  return [
    {
      id: "client",
      header: "Client",
      width: "minmax(240px,32%)",
      cell: (r) => <ClientCell row={r} />,
    },
    {
      id: "members",
      header: "Who can see it",
      width: "minmax(140px,1fr)",
      align: "center",
      priority: 2,
      cell: (r) => <MembersCell row={r} />,
    },
    {
      id: "primaryClientContact",
      header: "Primary Client Contact",
      width: "minmax(140px,1fr)",
      align: "center",
      priority: 2,
      cell: (row) => (
        <PrimaryClientContactCell primaryClientContact={resolvePrimaryClientContact(row)} />
      ),
    },
    {
      id: "reviews",
      header: "Reviews",
      width: "minmax(140px,1fr)",
      align: "center",
      priority: 2,
      cell: (r) => <ReviewsCell row={r} />,
    },
    {
      id: "since",
      header: "Since",
      width: "minmax(140px,1fr)",
      align: "center",
      priority: 2,
      cell: (r) => <SinceCell row={r} />,
    },
  ]
}
